import React from 'react';
import { TitlePage } from '../../TitlePage/TitlePage';
import { TextPage } from '../../TextPage/TextPage';
import './MetricCards.scss';

interface Metric {
    label: string;
    value: number;
}

interface MetricCardsProps {
    metrics: Metric[];
    selectedValues: number[];
    onSelectionChange: (selectedValues: number[]) => void;
    maxSelections?: number;
    loading: boolean
}

const MetricCards: React.FC<MetricCardsProps> = ({
    metrics,
    selectedValues = [],
    onSelectionChange,
    maxSelections = Infinity,
    loading
}) => {
    const handleCardClick = (metricValue: number) => {
        let newSelectedValues;

        if (selectedValues?.includes(metricValue)) {
            // Удаляем из выбранных
            newSelectedValues = selectedValues?.filter(value => value !== metricValue);
        } else {
            // Добавляем в выбранные, если не превышен лимит
            if (selectedValues.length >= maxSelections) {
                return;
            }
            newSelectedValues = [...selectedValues, metricValue];
        }

        onSelectionChange(newSelectedValues);
    };

    return (
        <div className="metric-cards-table__container">
            <TitlePage
                medium
                title='Метрики для таблицы'
            />

            <div className="metric-cards-table__grid">
                {
                    // loading ?
                    //     <MoonLoader
                    //         className="loader"
                    //         color="#7b7b7b"
                    //         speedMultiplier={0.5}
                    //         size={20}
                    //     /> :
                        metrics?.map((metric) => {
                            const isSelected = selectedValues.includes(metric.value);
                            const cardClass = isSelected
                                ? 'metric-cards-table__selected'
                                : 'metric-cards-table';

                            return (
                                <div
                                    key={metric.value}
                                    className={cardClass}
                                    onClick={() => handleCardClick(metric.value)}
                                >

                                    <div className="metric-cards-table__content">
                                        <TextPage
                                            text={metric.label}
                                        />
                                    </div>
                                </div>
                            );
                        })
                }
            </div>
        </div>
    );
};

export default MetricCards;